import { type FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { SearchInputProps } from '@/types';

import CloseCircleIcon from '@/assets/icons/close-circle.svg?react';
import SearchIcon from '@/assets/icons/search.svg?react';
import { Input } from '@/components/ui/input';
import useDebounce from '@/hooks/use-debounce';

const SearchInput: FC<SearchInputProps> = ({ initialValue, onChange }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(initialValue ?? '');

  const debounceValue = useDebounce(value, 500);

  const onClearInput = () => {
    setValue('');
  };

  useEffect(() => {
    if (onChange) {
      onChange(debounceValue);
    }
  }, [debounceValue, onChange]);

  return (
    <div className="relative">
      <SearchIcon
        aria-label="search-icon"
        name="search-icon"
        className="size-5 pointer-events-none absolute text-black left-3 top-1/2 h-[18px] w-[18px] -translate-y-1/2"
      />
      <Input
        type="text"
        placeholder={t('common.search')}
        name="search"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="peer block w-full placeholder-muted-foreground border shadow-xs py-2 pl-10 rounded-sm focus-visible:bg-background focus-visible:ring-offset-0 focus-visible:ring-0"
      />
      {value && (
        <CloseCircleIcon
          onClick={onClearInput}
          className="size-5 cursor-pointer absolute right-3 top-1/2 h-[18px] w-[18px] -translate-y-1/2"
          aria-label="search-clear-icon"
          name="search-clear-icon"
        />
      )}
    </div>
  );
};

export default SearchInput;
